/** Classe abstraite référence pour les patchs à appliquer.\
 * Les implémentations filles doivent être `@Injectable()`.
 */
export abstract class PatchBase {
	//#region PROPERTIES

	/** Description du patch. */
	public readonly patchDescription: string;

	//#endregion

	//#region METHODS

	constructor(psDescription: string) {
		this.patchDescription = psDescription;
	}

	/** Applique le patch. */
	public abstract applyPatchAsync(): Promise<boolean>;

	//#endregion
}
